import React from "react";
import ReactDOM from "react-dom";
import { APM_SERVER_URL, APM_ENVIRONMENT } from "./config/constants";
import { apm } from "./apm";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import store from "./store/configureStore";
import "semantic-ui-css/semantic.min.css";
import "./assets/css/style-main.css";
import "bootstrap/dist/js/bootstrap.js";
import { ClipboardProvider } from "./components/common/components/ImageComponents/ImageClipboardProvider";
import { initFeatureFlags, whenFlagsReady } from "./services/featureFlags";
import { applyReactTooltipPerfPatch } from "./utils/reactTooltipPerf";

// Must run before the first <ReactTooltip> mounts.
applyReactTooltipPerfPatch();

const renderApp = () =>
    ReactDOM.render(
        // <ErrorBoundary>
        <Provider store={store}>
            <ClipboardProvider>
                <div></div>
                <App />
            </ClipboardProvider>
        </Provider>,
        // </ErrorBoundary>,
        document.getElementById("root")
    );

// MIGRATION PREP: start Harness FME (Split.io) flag evaluation, then render once
// flag definitions have arrived. Mounting before they arrive makes the first
// requests of a session evaluate every flag as OFF, sending reads to the legacy
// Ruby gateway even when the flag is ON in FME. The wait is capped inside
// `whenFlagsReady()` and fail-safe — if no SDK key is configured or FME is
// unreachable, it resolves promptly and every flag resolves OFF.
initFeatureFlags();
whenFlagsReady().then(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
